export default "__VITE_ASSET__CyodYBZz__"